import * as z from 'zod/mini'

/**
 * Route search-param building blocks on zod/mini (a fraction of full zod in the entry bundle).
 * Every key falls back instead of failing, so an old bookmark or a hand-edited URL still opens.
 */
export { z }

/** A key with a default: missing or invalid values become `value`. */
export function withDefault<T extends z.ZodMiniType>(schema: T, value: z.output<T>) {
  return z.catch(z._default(schema, value as never), value as never)
}

/** An optional key: invalid values are dropped. */
export function optional<T extends z.ZodMiniType>(schema: T) {
  return z.catch(z.optional(schema), undefined)
}

/** Positive integer ids from the URL (`?page=3`, `?el=1834`). */
export const positiveInt = z.coerce.number().check(z.int(), z.positive())

export const langCode = z.string().check(z.regex(/^[a-z]{2,3}(-[A-Za-z0-9]{2,8})?$/))
